import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 45 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "22.5",
      cy: "22.5",
      r: "20.5",
      fill: "#fc3f1d",
      stroke: "#f5f5f6",
      "stroke-width": "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M25.596 15.434h-1.52c-2.79 0-4.256 1.3-4.256 3.217 0 2.166 1.014 3.182 3.096 4.483l1.72 1.067L19.695 31H16l4.436-6.082c-2.551-1.684-3.983-3.319-3.983-6.084 0-3.467 2.625-5.834 7.604-5.834H29v17.983h-3.404z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "boxberry"}) } }